export default function FeaturesSection() {
  const features = [
    {
      icon: "ri-shield-check-line",
      title: "免费观影",
      desc: "所有资源完全免费，无需注册、无需付费，打开即可观看。",
    },
    {
      icon: "ri-4k-line",
      title: "超清画质",
      desc: "1080P超清起步，部分内容支持4K播放，带来极致视觉享受。",
    },
    {
      icon: "ri-speed-up-line",
      title: "多线路切换",
      desc: "智能多线路切换技术，告别卡顿，任何网络环境都流畅播放。",
    },
    {
      icon: "ri-smartphone-line",
      title: "全平台支持",
      desc: "电脑、平板、手机无缝适配，无需下载APP，浏览器直接观看。",
    },
    {
      icon: "ri-flashlight-line",
      title: "极速更新",
      desc: "热门内容24小时内上线，综艺节目当天同步，追剧快人一步。",
    },
    {
      icon: "ri-advertisement-line",
      title: "纯净无广告",
      desc: "全程无广告打扰，不插播、不弹窗，还你一个干净的观影空间。",
    },
  ];

  return (
    <section className="py-10 md:py-14 bg-background-100/80">
      <div className="max-w-7xl mx-auto px-4 md:px-6">
        <div className="text-center mb-10">
          <h2 className="text-2xl md:text-3xl font-heading font-bold text-foreground-900">
            为什么选择<strong>红桃影视</strong>
          </h2>
          <p className="mt-2 text-sm text-foreground-500">六大核心优势，打造极致观影体验</p>
        </div>

        <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-3 gap-5">
          {features.map((feat, i) => (
            <div
              key={i}
              className="flex gap-4 p-5 rounded-xl bg-background-50 border border-background-200/60 hover:border-primary-100 transition-all duration-300 group"
            >
              <div className="w-12 h-12 rounded-xl bg-accent-100 flex items-center justify-center flex-shrink-0 group-hover:bg-accent-200 transition-colors">
                <i className={`${feat.icon} text-xl text-accent-700`}></i>
              </div>
              <div>
                <h3 className="text-base font-semibold text-foreground-900 mb-1">{feat.title}</h3>
                <p className="text-sm text-foreground-500 leading-relaxed">{feat.desc}</p>
              </div>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
}